import { useWalletDetails } from "@sundae/wallet-react";
import { useQuery } from "@tanstack/react-query";
import { ZEROES } from "../constants/general.js";
import { unixToSlot } from "../utils/slots.js";
export function rewardTentative(reward) {
    return reward.tentative;
}
export function rewardUnavailable(reward, now) {
    return reward.availableAt && now < reward.availableAt;
}
export function rewardExpired(reward, now) {
    return reward.expiresAt && reward.expiresAt < now;
}
export const rewardClaimed = (reward) => reward.seenTxId === ZEROES ||
    (reward.seenTxId !== "" && reward.seenTxId === reward.paidTxId);
export function rewardOnCooldown(reward, now, network) {
    const currentSlot = unixToSlot(Math.floor(new Date(now).valueOf() / 1000), network);
    return (reward.paidTxId !== "" &&
        reward.seenTxId === "" &&
        reward?.invalidAt < currentSlot &&
        reward?.invalidAt < reward?.finalAt);
}
export function canClaimRewards(reward, now, network) {
    // If this reward is tentative, we can't claim it
    if (rewardTentative(reward)) {
        return false;
    }
    // If this reward isn't available yet, we can't claim it
    if (rewardUnavailable(reward, now)) {
        return false;
    }
    // If this reward has expired, we can't claim it
    if (rewardExpired(reward, now)) {
        return false;
    }
    // If they've claimed it already, then we can't claim
    if (rewardClaimed(reward)) {
        return false;
    }
    // If the reward is in "cooldown", we can't claim it right now
    if (rewardOnCooldown(reward, now, network)) {
        return false;
    }
    return true;
}
export const useRewards = () => {
    const { isLoaded, details: { mainAddress, stakingAddress, usedAddresses, unusedAddresses }, } = useWalletDetails();
    return useQuery(["rewards", mainAddress], async () => {
        const remainingAddresses = [
            stakingAddress,
            ...usedAddresses,
            ...unusedAddresses,
        ];
        if (remainingAddresses.length == 0) {
            return null;
        }
        const rewards = {};
        while (remainingAddresses.length > 0) {
            const nextAddresses = remainingAddresses.splice(0, 100);
            console.log("Fetching rewards for batch of addresses", nextAddresses);
            const data = await fetch(window.__APP_CONFIG.apiUrls.rewards, {
                method: "POST",
                body: JSON.stringify({
                    addresses: nextAddresses,
                }),
            }).then((res) => res.json());
            for (const key in data.rewards) {
                rewards[key] = data.rewards[key];
            }
        }
        return {
            rewards,
        };
    }, {
        enabled: isLoaded,
        staleTime: 1000 * 60 * 5,
        cacheTime: 1000 * 60 * 25,
    });
};
//# sourceMappingURL=useRewards.js.map